import "./loader.css";

const Loader = () => {
  return (
    <div id="modal-root">
      <div className="spinner-box">
        <div className="loading-icon" />
        <span>Loading...</span>
      </div>
    </div>
  );
};

export default Loader;
